import Node from 'components/Editor/cource/layout/Node'

import { useElementRootStyles } from '../../hooks/useElementRootStyles'
import * as s from './LayoutListElement.module.scss'
import type { LayoutListElementType } from './layoutListTypes'

const LayoutListElement: LayoutListElementType = ({ block, element, styles, mode }) => {
  const { items } = element.value

  const rootStyles = useElementRootStyles(styles.root)
  const alignStyles: React.CSSProperties =
    styles.settings.flexDirection === 'row'
      ? {
          justifyContent: styles.settings.justifyContent,
          flexWrap: 'wrap',
        }
      : {
          alignItems: styles.settings.justifyContent,
        }

  return (
    <div
      className={s.root}
      style={{
        ...styles.indents,
        ...rootStyles,
        ...alignStyles,
        flexDirection: styles.settings.flexDirection,
      }}
    >
      {items.map(({ value }) => (
        <div className={s.item} key={value}>
          <Node block={block!} id={value} mode={mode} isItem />
        </div>
      ))}
    </div>
  )
}

export default LayoutListElement
